import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import ar from '../locales/ar.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage']
    }
  });

const setDirection = (lng: string) => {
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
};

// Mirror the chosen language into the Cache API, where the FCM service worker
// can read it. i18next persists to localStorage, which service workers cannot
// access — without this mirror, background pushes fell back to the browser
// language and ignored the language the customer chose in the app.
const mirrorLanguageForServiceWorker = (lng: string) => {
  if (typeof caches === 'undefined') return;
  caches
    .open('kw-app-prefs')
    .then((cache) => cache.put('/app-language', new Response(lng === 'ar' ? 'ar' : 'en')))
    .catch(() => {
      // The SW falls back to the browser language when nothing is stored.
    });
};

const onLanguage = (lng: string) => {
  setDirection(lng);
  mirrorLanguageForServiceWorker(lng);
};

onLanguage(i18n.language);

i18n.on('languageChanged', onLanguage);

export default i18n;
